import React from "react"
import { css } from "@jsUtils"

import { Circle } from "../Circle"

import Styles from "./circleButton.module.scss"

/**
 * Circle shaped button
 * @param {object} props - react props
 * @param {COLORS.BLUE|COLORS.FLURO|COLORS.WORKS} props.color - circle color. . If specified, affects all states.
 * @param {string} props.theme - background theme (light/dark)
 * @param {string} props.size - button size
 * @param {boolean} props.filled - filled styling
 * @param {boolean} props.flipped - horizontally flipped
 * @param {'chevron'|'plusMinus'|'play'|'pause'|undefined} props.content -  symbol name. Symbols are generated internally by CSS.
 * @param {string} props.label - button label
 * @param {string} props.type - button type
 * @param {function} props.onClick - function to trigger on click
 * @param {string} props.className - class name
 * @param {boolean} props.disableButton - do we disable the button or not?
 * @param {object} props.dataProps - data properties injected by the Analytics HOC
 */
const CircleButton = props => {
  const {
    theme,
    color,
    size,
    filled,
    flipped,
    className,
    disableButton,
    content,
    label,
    type,
    onClick,
    dataProps
  } = props
  return (
    <button
      {...dataProps}
      disabled={disableButton}
      type={type || "button"} // eslint-disable-line
      aria-label={label}
      className={css(Styles.circleButton, className, disableButton && Styles.disabled)}
      onClick={e => {
        if (onClick) {
          onClick(e)
        }
      }}
    >
      <Circle
        theme={theme}
        color={color}
        size={size}
        filled={filled}
        flipped={flipped}
        content={content}
      />
    </button>
  )
}

export default CircleButton
